import React, { useEffect, useState } from "react";
import {
  Button,
  Offcanvas,
  Table,
  Tabs,
  Tab,
  Modal,
  Form,
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import {
  WidgetsOutlined,
  BookmarkBorderOutlined,
  AddOutlined,
  WallpaperOutlined,
  DeleteForeverOutlined,
  ModeEditOutlined,
  VisibilityOutlined,
  DragHandleOutlined,
  ArrowForwardIosOutlined,
  ErrorOutline
} from "@mui/icons-material";
import useForm from "../../hooks/useForm";
import clienteAxios from "../../config/clienteAxios";
import toast from "react-hot-toast";
import { idGenerator } from "../../helpers/idGenerator";
import useProduct from "../../hooks/useProduct";
import GaleriaPgiModal from "../../pages/pgi/GaleriaPgiModal";
import usePgiModules from "../../hooks/useModules";
import useHome from "../../hooks/useHome";
import TinyMCE from "./tinyMCE";
import { v4 as uuidv4 } from "uuid";

const SidebarSubProducts = ({ productoPadre, replicaPgi, mensaje, idProduct }) => {
  const { product, setProduct, deleteSubProduct } = useProduct();
  const [product2, setProduct2] = useState(product);
  const [nuevoSubProduct, setNuevoSubProduct] = useState(null);
  const [editSubProduct, setEditSubProduct] = useState(null);
  const [subProductEdit, setSubProductEdit] = useState({});
  const [showCreateBanner, setShowCreateBanner] = useState(false);
  const handleCloseBanner = () => setShowCreateBanner(false);
  const [modalFor, setModalFor] = useState(null);
  const [modulesNew, setModulesNew] = useState(null);
  const handleShowBanner = () => setShowCreateBanner(!showCreateBanner);
  const { values, setValues, handleInputChange, reset } = useForm({
    _id: idGenerator(12),
    title: "",
    description: "",
    category: "",
    subCategory: "",
    subdescription: "",
    dimension: "",
    quantity: "",
    weight: "",
    imageLogo: [],
    imageIcon: [],
    imageProduct: [],
    imageProduct_webp: [],
    imageIconColor: [],
    imageLogoColor: [],
    imageProductAlpha: [],
    state: true,
    visible: false,
    productId: productoPadre._id,
    productTitle: productoPadre.title,
    tabs: []
  });

  // MODAL GALERIA
  const [showGaleria, setShowGaleria] = useState(false);
  const handleCloseGaleria = () => setShowGaleria(false);
  const handleShowGaleria = () => setShowGaleria(true);
  const [selectBanner, setSelectBanner] = useState(false);
  const [selectBloque, setSelectBloque] = useState(false);
  const { modules, handleVisibility, setModules, getModulesByParams, handleModuleUpdate } =
    usePgiModules();
  const { banners, handleVisibilityBanners, bloques, handleVisibilityBloque } = useHome();
  const arrayBanner = banners?.find((banner) => banner.state === true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const titleRegex = /^[a-zA-ZÀ-ÿ\s\d_!#$%&+,./:;=?@[\]^_`{|}~]+$/;
    const title = values.title.trim();

    if (!title || !titleRegex.test(title)) {
      toast.error("Este título contiene caracteres no válidos");
      return;
    }
    try {
      if (product.subproduct.find((subproduct) => subproduct._id === values._id)) {
        const { data } = await clienteAxios.put("/subproduct/update", values);
        toast.success(data.message);
        setProduct({
          ...product,
          subproduct: [
            ...product.subproduct.filter((subproduct) => subproduct._id !== values._id),
            values
          ]
        });
      } else {
        const { data } = await clienteAxios.post(`/subproduct/create`, values);
        toast.success(data.message);
        setProduct({ ...product, subproduct: [...product.subproduct, values] });
        reset();
      }
    } catch (error) {
      // toast.error(error);
      if (error.response.status === 400) {
        toast.error("Campos incompletos");
      }

      if (error.response.status === 404) {
        toast.error("Inconsistencia de datos");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    }
  };

  const handleDelete = (subproduct) => {
    const toastId = toast(
      <div className="flex-column">
        <div className="text-center error_icon">
          <ErrorOutline />
        </div>
        <div className="text-center my-2">¿Estas seguro de eliminar este subproducto?</div>
        <div className="d-flex justify-content-around">
          <Button
            className="w-40 button_error"
            variant="danger"
            onClick={() => handleDeleteConfirm(subproduct)}
          >
            Si
          </Button>
          <Button
            className="w-40 button_error"
            variant="secondary"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </Button>
        </div>
      </div>,
      {
        duration: 20000
      }
    );
  };

  const handleDeleteConfirm = async (subproduct) => {
    subproduct.state = false;
    try {
      const { data } = await clienteAxios.put("/subproduct/update", subproduct);
      toast.dismiss();
      toast.success(data.message);
      setProduct({
        ...product,
        subproduct: [
          ...product.subproduct.filter((subproduct) => subproduct.title !== values.title)
        ]
      });
      window.location.reload();
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  const handleEdit = async (subproduct) => {
    setNuevoSubProduct(true);
    setEditSubProduct(true);
    setValues({
      ...subproduct
    });
    setSubProductEdit(subproduct);
  };

  const handleVisibilitySubproduct = async (subproduct) => {
    setProduct({
      ...product,
      subproduct: product.subproduct.map((item) => {
        if (item._id === subproduct._id) {
          if (item.visible) {
            item.visible = false;
          } else {
            item.visible = true;
          }
        }
        return item;
      })
    });
    try {
      const { data } = await clienteAxios.put("/subproduct/update", subproduct);
      toast.success(data.message);
      // window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  const handleNuevoSubProduct = async () => {
    reset();
    setNuevoSubProduct(true);
    setEditSubProduct(false);
  };

  const handleModalClick = (modalFor) => {
    setModalFor(modalFor);
    handleShowGaleria();
  };

  const handleAddTab = () => {
    const randomID = uuidv4();
    setValues({
      ...values,
      tabs: [
        ...values.tabs,
        {
          // id: Number(Math.random()),
          id: randomID,
          title: "",
          description: ""
          // stepWarningText: "",
        }
      ]
    });
  };
  useEffect(() => {
    getModulesByParams({ state: true }).then((res) => {
      setModules(res.sort((a, b) => a.position - b.position));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setModulesNew(
      modules?.filter(
        (module) =>
          module?.title === "Carrousel_deLinea" ||
          module?.title === "Carrousel_especial" ||
          module?.title === "Banner_publicitario" ||
          module?.title === "Bloque_info"
      )
    );
  }, [modules]);

  const handleDeleteTab = (index, tabId) => {
    setValues({
      ...values,
      tabs: values.tabs.filter((tab) => tab.id !== tabId)
    });
  };

  const handleTabInput = ({ target }) => {
    setValues({
      ...values,
      tabs: values.tabs.map((tab, i) => {
        // if (tab.id === Number(target.id)) {
        if (tab.id === target.id) {
          return { ...tab, [target.name]: target.value };
        }
        return tab;
      })
    });
  };

  return (
    <div className="pgi__sidebar-slides">
      {replicaPgi ? (
        <button className="settings_button-pleno" onClick={handleShowBanner}>
          {mensaje}
        </button>
      ) : (
        <OverlayTrigger
          key="1"
          placement="top"
          overlay={<Tooltip id="1">Ver Subproductos</Tooltip>}
        >
          <Button className="btn-form-pgi" variant="light" onClick={handleShowBanner}>
            {productoPadre.title}
          </Button>
        </OverlayTrigger>
      )}
      {/**INICIO OFF CANVAS */}
      <Offcanvas
        show={showCreateBanner}
        onHide={handleCloseBanner}
        className="basePgi__pgi  pgi__sidebar-container"
        placement="end"
        scroll="true"
        enforceFocus
        backdrop={false}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            SUBPRODUCTOS
            {/* EN EDITAR el title -->
                Producto / <b>Tensoblock</b> */}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form id="formEditarHSlider" className="basePgi__vista-edit-gral">
            <header aria-labelledby="formEditarHSlider">
              <h2>{product.title}</h2>{" "}
              <Button className="btn-form-pgi" variant="light" onClick={handleNuevoSubProduct}>
                <OverlayTrigger
                  key="1"
                  placement="top"
                  overlay={<Tooltip id="1">Nuevo Subproducto</Tooltip>}
                >
                  <AddOutlined />
                </OverlayTrigger>
              </Button>
            </header>
            <Table className="basePgi__table-list" hover>
              <colgroup>
                <col span="1" className="basePgi__table-col-position" />
                <col span="2" className="basePgi__table-col-max" />
                <col span="3" className="basePgi__table-col-min" />
              </colgroup>
              <tbody>
                {/*************** solo maqueta ************************* 

                  */}
                {product.subproduct?.map((subproduct, index) => {
                  if (subproduct.state) {
                    return (
                      <>
                        <tr key={index}>
                          <td className="pgi__table-position-number">
                            <b>{subproduct.title}</b>
                          </td>
                          <td></td>
                          <td>{subproduct.category}</td>
                          <td>
                            <OverlayTrigger
                              key="1"
                              placement="top"
                              overlay={<Tooltip id="1">Visibilidad</Tooltip>}
                            >
                              <Button
                                className={subproduct.visible ? "" : "disabled"}
                                onClick={() => handleVisibilitySubproduct(subproduct)}
                              >
                                <VisibilityOutlined />
                              </Button>
                            </OverlayTrigger>
                          </td>
                          <td>
                            <OverlayTrigger
                              key="1"
                              placement="top"
                              overlay={<Tooltip id="1">Editar</Tooltip>}
                            >
                              <Button onClick={() => handleEdit(subproduct)}>
                                <ModeEditOutlined />
                              </Button>
                            </OverlayTrigger>
                          </td>
                          <td onClick={() => deleteSubProduct(subproduct._id)}>
                            <OverlayTrigger
                              key="1"
                              placement="top"
                              overlay={<Tooltip id="1">Eliminar</Tooltip>}
                            >
                              <Button onClick={() => handleDelete(subproduct)}>
                                <DeleteForeverOutlined />
                              </Button>
                            </OverlayTrigger>
                          </td>
                        </tr>
                      </>
                    );
                  }
                })}
                {/*************** end solo maqueta ************************* */}
              </tbody>
            </Table>
          </form>
          <hr className="basePgi__space-line" />
          {nuevoSubProduct && values && (
            <>
              <header aria-labelledby="formEditarHSlider">
                <h2>{editSubProduct ? subProductEdit.title : "Nuevo subproducto"}</h2>{" "}
              </header>

              <Tabs
                defaultActiveKey="descripcion"
                active
                id="productos-tab"
                className="pgi__productos-tab"
              >
                <Tab eventKey="descripcion" title="Descripción">
                  <form
                    className="basePgi__vista-edit-gral"
                    id="bloque-txt"
                    onSubmit={handleSubmit}
                  >
                    <fieldset className="pgi__sidebar-container-items form-group">
                      <div className="form-floating">
                        <input
                          required
                          type="text"
                          className="form-control"
                          name="title"
                          id="title"
                          placeholder="..."
                          value={values.title}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="title">Nombre del subproducto </label>
                        <p className="basePgi__comments">
                          <span>No se admiten los siguentes caracteres: "" ( ) * - </span>
                        </p>
                      </div>
                      <div className="form-floating">
                        <input
                          required
                          type="text"
                          className="form-control"
                          name="category"
                          id="category"
                          placeholder="..."
                          value={values.category}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="category">Categoría</label>
                      </div>
                      <div className="form-floating">
                        <input
                          required
                          type="text"
                          className="form-control"
                          name="subCategory"
                          id="subCategory"
                          placeholder="..."
                          value={values.subCategory}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="subCategory">Sub Categoría</label>
                      </div>
                      <div className="form-floating">
                        <textarea
                          required
                          type="text-area"
                          className="form-control"
                          name="description"
                          id="description"
                          rows="4"
                          for="bloque-txt"
                          placeholder="..."
                          value={values.description}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="content">Descripción</label>
                      </div>
                      <div className="form-floating">
                        <textarea
                          required
                          type="text-area"
                          className="form-control"
                          name="subdescription"
                          id="subdescription"
                          rows="1"
                          for="bloque-txt"
                          placeholder="..."
                          value={values.subdescription}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="subdescription">Sub Descripción</label>
                      </div>
                      <div className="form-floating">
                        <input
                          required
                          type="text"
                          className="form-control"
                          name="dimension"
                          id="dimension"
                          placeholder="..."
                          value={values.dimension}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="dimension">Dimensión (cm)</label>
                      </div>
                      <div className="form-floating">
                        <input
                          required
                          type="text"
                          className="form-control"
                          name="quantity"
                          id="quantity"
                          placeholder="..."
                          value={values.quantity}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="quantity">Cantidad/m2 </label>
                      </div>
                      <div className="form-floating">
                        <input
                          required
                          type="text"
                          className="form-control"
                          name="weight"
                          id="weight"
                          placeholder="..."
                          value={values.weight}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="weight">Peso (Kg) </label>
                      </div>
                      <button
                        type="submit"
                        className="settings_button-pleno"
                        onClick={handleSubmit}
                      >
                        GUARDAR
                      </button>
                    </fieldset>
                    <hr className="basePgi__space-line" />
                  </form>
                </Tab>
                {/* *************TABS IMAGENES *************************************** */}
                <Tab eventKey="imagenes" title="Imágenes">
                  <form className="basePgi__vista-edit-gral">
                    <div className="form-floating">
                      <div className="pgi__container-img" style={{ display: "none" }}>
                        {/*implementar selector de images *** eliminar style={{}} al agregar imagenes*/}
                      </div>
                      {/*implementar: al editar banner cambiar x "REEMPLAZAR"*/}
                      <Button
                        className="btn-form-pgi pgi__head-modules"
                        onClick={() => handleModalClick("logotipo")}
                      >
                        Seleccionar Logotipo
                        <BookmarkBorderOutlined />
                      </Button>
                      <div className="pgi__container-img" style={{ display: "none" }}>
                        {/*implementar selector de images *** eliminar style={{}} al agregar imagenes*/}
                      </div>
                      {/*implementar: al editar banner cambiar x "REEMPLAZAR"*/}
                      {/* <Button className="btn-form-pgi pgi__head-modules">
                    Seleccionar ícono
                    <AppsOutlined />
                  </Button> */}
                      {/*implementar: al editar banner cambiar x "REEMPLAZAR"*/}
                      <Button
                        className="btn-form-pgi pgi__head-modules"
                        onClick={() => handleModalClick("imagen_producto")}
                      >
                        Seleccionar imagen producto
                        <WidgetsOutlined />
                      </Button>
                      <p className="basePgi__comments">
                        <span>
                          Imagen para Escritorio (.jpg, .png). Proporción 4:3. Ancho máximo 2048px
                        </span>
                      </p>
                      <Button
                        className="btn-form-pgi pgi__head-modules"
                        onClick={() => handleModalClick("imagen_producto_webp")}
                      >
                        Seleccionar imagen producto (.webP)
                        <WallpaperOutlined />
                      </Button>
                      <p className="basePgi__comments">
                        <span>
                          Imagen para Escritorio (.webP). Proporción 4:3. Ancho máximo 2048px
                        </span>
                      </p>
                    </div>
                    {/* <button
                  type="submit"
                  className="settings_button-pleno"
                  onClick={handleSubmit}
                >
                  Guardar imágenes
                </button> */}
                  </form>
                  <hr className="basePgi__space-line" />
                  {/* MODAL GALERIA */}
                  <Modal
                    id="galleryModal"
                    className="modalContenedor__galeria"
                    show={showGaleria}
                    onHide={handleCloseGaleria}
                  >
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                      <GaleriaPgiModal
                        editProduct={values}
                        setEditProduct={setValues}
                        modalFor={modalFor}
                        handleCloseGaleria={handleCloseGaleria}
                      />
                    </Modal.Body>
                  </Modal>
                </Tab>

                {/* *************TABS Modulos *************************************** */}

                <Tab eventKey="Módulos" title="Módulos">
                  <form id="formEditarHModulos" className="basePgi__vista-edit-gral">
                    <header aria-labelledby="formEditarHModulos">
                      <h2>Módulos</h2>
                    </header>
                    <Table className="basePgi__table-list" hover>
                      <colgroup>
                        <col span="1" className="basePgi__table-col-min" />
                        <col span="1" className="basePgi__table-col-position" />
                        <col span="1" className="basePgi__table-col-max" />
                        <col span="1" className="basePgi__table-col-min" />
                        <col span="1" className="basePgi__table-col-max" />
                        <col span="2" className="basePgi__table-col-min" />
                      </colgroup>
                      <tbody>
                        {
                          // mapeo automatico de tabla de modulos
                          modulesNew?.map((module, index) => {
                            return (
                              <>
                                <tr key={index}>
                                  <td>
                                    <Button disabled>
                                      <DragHandleOutlined />
                                    </Button>
                                  </td>
                                  <td className="pgi__table-position-number">
                                    <b>{index + 1}</b>
                                  </td>
                                  <td className="pgi__module-name">{module.title}</td>
                                  <td>{module.moduleType}</td>
                                  {module.title === "Banner_publicitario" ? (
                                    <td>{arrayBanner?.title ? arrayBanner?.title : ""}</td>
                                  ) : (
                                    <td>{module?.content ? module.content[index] : ""}</td>
                                  )}

                                  <td>
                                    <OverlayTrigger
                                      key="1"
                                      placement="top"
                                      overlay={<Tooltip id="1">Visibilidad</Tooltip>}
                                    >
                                      <Button
                                        className={
                                          module.visible.find(
                                            (item) => item === `${subProductEdit._id}`
                                          )
                                            ? ""
                                            : "disabled"
                                        }
                                        onClick={() =>
                                          handleVisibility(module, `${subProductEdit._id}`)
                                        }
                                      >
                                        <VisibilityOutlined />
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                  {module.editable ? (
                                    <td>
                                      {/* <Button><ModeEditOutlined/></Button> */}
                                      {module.title === "Banner_publicitario" && (
                                        <OverlayTrigger
                                          key="1"
                                          placement="top"
                                          overlay={<Tooltip id="1">Ver banners</Tooltip>}
                                        >
                                          <Button onClick={() => setSelectBanner(!selectBanner)}>
                                            <ArrowForwardIosOutlined />
                                          </Button>
                                        </OverlayTrigger>
                                      )}
                                      {module.title === "Bloque_info" && (
                                        <OverlayTrigger
                                          key="1"
                                          placement="top"
                                          overlay={<Tooltip id="1">Ver Bloques</Tooltip>}
                                        >
                                          <Button onClick={() => setSelectBloque(!selectBloque)}>
                                            <ArrowForwardIosOutlined />
                                          </Button>
                                        </OverlayTrigger>
                                      )}
                                    </td>
                                  ) : (
                                    <td></td>
                                  )}
                                </tr>
                              </>
                            );
                          })
                        }
                      </tbody>
                    </Table>
                    <button
                      type="button"
                      className="settings_button-pleno"
                      onClick={handleModuleUpdate}
                    >
                      Modificar Módulos
                    </button>
                  </form>
                  <hr className="basePgi__space-line" />

                  {selectBanner === true && (
                    <>
                      <form action="" id="formEditarHModulos" className="basePgi__vista-edit-gral">
                        <header aria-labelledby="formEditarHModulos">
                          <h2>Selecciona los banners</h2>
                        </header>
                        <Table className="basePgi__table-list" hover>
                          <colgroup>
                            <col span="1" className="basePgi__table-col-min" />
                            <col span="1" className="basePgi__table-col-max" />
                            <col span="2" className="basePgi__table-col-min" />
                          </colgroup>
                          <tbody>
                            {banners?.map(
                              (banner) =>
                                banner?.deleted === false && (
                                  <>
                                    <tr key={banner._id}>
                                      <td className="pgi__table-check">
                                        <Form.Check
                                          inline
                                          aria-label="banner #id" // indicar x variable el nº id
                                          name="selectBanner"
                                          type="checkbox"
                                          id="align-left"
                                          defaultChecked={banner.section.find(
                                            (item) => item === `${subProductEdit._id}`
                                          )}
                                          onClick={() => {
                                            handleVisibilityBanners(
                                              banner._id,
                                              `${subProductEdit._id}`
                                            );
                                          }}
                                        />
                                      </td>
                                      <td>{banner.title}</td>
                                    </tr>
                                  </>
                                )
                            )}
                          </tbody>
                        </Table>
                      </form>
                    </>
                  )}

                  {selectBloque === true && (
                    <>
                      <form action="" id="formEditarHModulos" className="basePgi__vista-edit-gral">
                        <header aria-labelledby="formEditarHModulos">
                          <h2>Selecciona los bloques de info</h2>
                        </header>
                        <Table responsive className="basePgi__table-list" hover>
                          <colgroup>
                            <col span="1" className="basePgi__table-col-min" />
                            <col span="1" className="basePgi__table-col-max" />
                            <col span="2" className="basePgi__table-col-min" />
                          </colgroup>
                          <tbody>
                            {bloques?.map(
                              (bloque) =>
                                bloque?.deleted === false && (
                                  <>
                                    <tr key={bloque._id}>
                                      <td className="pgi__table-check">
                                        <Form.Check
                                          inline
                                          aria-label="banner #id" // indicar x variable el nº id
                                          name="selectBanner"
                                          type="checkbox"
                                          id="align-left"
                                          defaultChecked={bloque.visible.find(
                                            (item) => item === `${subProductEdit._id}`
                                          )}
                                          onClick={() => {
                                            handleVisibilityBloque(
                                              bloque._id,
                                              `${subProductEdit._id}`
                                            );
                                          }}
                                        />
                                      </td>
                                      <td>{bloque.title_content}</td>
                                    </tr>
                                  </>
                                )
                            )}
                          </tbody>
                        </Table>
                      </form>
                    </>
                  )}
                </Tab>
                {/* *************TABS Modulos *************************************** */}
                <Tab eventKey="tabs" title="Tabs">
                  <Form className="basePgi__vista-edit-gral" onSubmit={handleSubmit}>
                    {/* <Form.Check
                      type="switch"
                      id="pgiInstallSwitch"
                      label="Habilitar sección"
                      className="pgi__switchCheck"
                    /> */}
                    <fieldset className="pgi__sidebar-container-items">
                      <h3>TABS</h3>
                      <button
                        type="submit"
                        className="settings_button-pleno float-end m-0 botton-save-pgi"
                      >
                        GUARDAR
                      </button>
                      <p className="basePgi__comments">
                        Desde aquí podrá cargar las tabs de un subproducto con la información
                        adicional
                      </p>
                      <div className="pgi__archivo pgi__install">
                        {values.tabs.map((tab, index) => {
                          return (
                            <>
                              <div className="input-group" key={tab.id}>
                                {/* <label htmlFor="tabTitle">{index + 1}</label> */}
                                <input
                                  type="text"
                                  className="form-control"
                                  name="title"
                                  placeholder="Titulo"
                                  id={tab.id}
                                  defaultValue={tab?.title}
                                  onChange={handleTabInput}
                                  maxLength={90}
                                  minLength={2}
                                />
                                <OverlayTrigger
                                  key="1"
                                  placement="top"
                                  overlay={<Tooltip id="1">Eliminar</Tooltip>}
                                >
                                  <Button onClick={() => handleDeleteTab(index, tab.id)}>
                                    <DeleteForeverOutlined />
                                  </Button>
                                </OverlayTrigger>
                              </div>
                              <TinyMCE
                                id={tab.id}
                                values={tab?.description}
                                handleInputChange={handleTabInput}
                                name="description"
                              />
                            </>
                          );
                        })}
                        {/*implementar selector de images *** eliminar style={{}} al agregar imagenes*/}
                      </div>
                      <OverlayTrigger
                        key="1"
                        placement="top"
                        overlay={<Tooltip id="1">Nuevo Tab</Tooltip>}
                      >
                        <Button
                          variant="light"
                          className="btn-form-pgi allW"
                          onClick={handleAddTab}
                        >
                          <AddOutlined />
                        </Button>
                      </OverlayTrigger>
                    </fieldset>
                  </Form>
                </Tab>
              </Tabs>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default SidebarSubProducts;
